import { render } from "./DriverReturns.vue?vue&type=template&id=71ef4480&scoped=true"
import script from "./DriverReturns.vue?vue&type=script&lang=js"
export * from "./DriverReturns.vue?vue&type=script&lang=js"

import "./DriverReturns.vue?vue&type=style&index=0&id=71ef4480&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ef4480"]])

export default __exports__